export default "__VITE_ASSET__3b4d3db4__"